import React from 'react'
import { Form, Input } from 'antd'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'
import Access from '../../../../../../components/access/Access'
import { TEST_NAME_LIMIT } from '../../../../../../../../constants/input-limits'

const TestName = ({ initialValue }) => {
    return (
        <Form.Item label='Name' name='name' rules={[
            { required: true, message: 'Please, enter name' },
            { max: TEST_NAME_LIMIT, message: `Test name cannot exceed ${TEST_NAME_LIMIT} characters` }
        ]}>
            <Access
                rules={[Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED]}
                fallback={<Text>{initialValue}</Text>}
            >
                <Input maxLength={TEST_NAME_LIMIT} showCount/>
            </Access>
        </Form.Item>
    )
}

export default TestName
